export const DATA_EXPORT_SCHEMA_CONFIG_KEY = ['data-export-schema-config'];
